import { Utils } from '@/types';
import { parsePhoneNumber } from 'awesome-phonenumber';
import i18n from '../plugins/i18n';

export function validateEmail(email: string): string {
  if (!email) {
    return String(i18n.global.t('errors.emailValidation.required'));
  }

  if (email.length > 254) {
    return String(i18n.global.t('errors.emailValidation.invalid'));
  }

  const tester =
    /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-?\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
  const valid = tester.test(email);
  if (!valid) {
    return String(i18n.global.t('errors.emailValidation.invalid'));
  }

  const parts = email.split('@');
  if (parts[0].length > 64) {
    return String(i18n.global.t('errors.emailValidation.invalid'));
  }

  const domainParts = parts[1].split('.');
  if (
    domainParts.some(part => {
      return part.length > 63;
    })
  ) {
    return String(i18n.global.t('errors.emailValidation.invalid'));
  }

  return '';
}

export function validatePhone(
  phone: string,
  countries?: Utils.Countries.Country[],
): string {
  if (!phone) {
    return String(i18n.global.t('errors.field.empty'));
  }

  const phoneFormatted = phone.startsWith('+')
    ? phone
    : phone.length > 0
    ? `+${phone}`
    : '';

  const ph = parsePhoneNumber(phoneFormatted);
  if (!ph.valid) {
    return String(i18n.global.t('errors.field.invalidPhone'));
  }

  if (
    countries &&
    !countries.some(
      country =>
        country.iso2 === ph.regionCode || country.iso3 === ph.regionCode,
    )
  ) {
    return String(i18n.global.t('errors.field.invalidPhone'));
  }

  return '';
}

export function validateName(value: string): string {
  const regex = /^[a-zA-Z\s\-]*$/;

  if (!value) return String(i18n.global.t('errors.field.empty'));
  if (!regex.test(value))
    return String(i18n.global.t('errors.field.invalidName'));

  return '';
}
